import { SelfServeNodes } from "@faire/help-center-self-serve/types";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { BulkSelect } from "@faire/web--source/slate/icons/foundation/BulkSelect";
import React from "react";

import { CheckAccountVerificationStatusIA } from "../instantAnswers/myAccount-checkAccountVerificationStatus";
import { DoNotHaveRequestedInfoIA } from "../instantAnswers/myAccount-doNotHaveReuqestedInfo";
import { ProvideRequestedInfoIA } from "../instantAnswers/myAccount-provideRequestedInfo";
import { AccountVerificationPendingVisibilityFn } from "../visibilityFunctions/accountVerificationPendingVisibilityFn";

export const useVerifyAccountRetailerNodes = (): SelfServeNodes => {
  const { strictLocalize } = useStrictLocalization();
  const articles = useArticles();
  return {
    VerifyAccount: {
      id: "VerifyAccount",
      label: strictLocalize({
        defaultMessage: "Verify account",
        description: {
          text: "A top level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      icon: <BulkSelect fontSize="24px" color="faireBlack" />,
      children: [
        "CheckVerificationStatus",
        "ProvideVerificationInformation",
        "InCompleteVerification",
      ],
      level: 1,
      sidebarTitle: strictLocalize({
        defaultMessage: "Verify account issue",
        description: {
          text: "Title for displaying on the order summary sidebar",
        },
      }),
      isNodeVisible: AccountVerificationPendingVisibilityFn,
    },
    ProvideVerificationInformation: {
      id: "ProvideVerificationInformation",
      label: strictLocalize({
        defaultMessage: "Provide verification information",
        description: {
          text: "A third level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      articles: [articles.Account.ORDER_ISSUE],
      instantAnswer: ProvideRequestedInfoIA(strictLocalize),
      level: 3,
    },
    InCompleteVerification: {
      id: "InCompleteVerification",
      label: strictLocalize({
        defaultMessage: "Incomplete verification",
        description: {
          text: "A third level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      articles: [articles.Account.NOT_OPEN],
      instantAnswer: DoNotHaveRequestedInfoIA(strictLocalize, articles),
      level: 3,
    },
    CheckVerificationStatus: {
      id: "CheckVerificationStatus",
      label: strictLocalize({
        defaultMessage: "Check verification status",
        description: {
          text: "A third level issue node in the full page self-serve experience of Faire's Help Center",
        },
      }),
      articles: [articles.MyOrders.BUSINESS_PROFILE],
      instantAnswer: CheckAccountVerificationStatusIA(strictLocalize, articles),
      level: 3,
    },
  };
};
